// /**
//  * Center - edit
//  */

// React
import React, {useEffect} from 'react';

import {connect} from 'react-redux';
import {compose} from 'redux';
import {Store} from '../../../../redux/reducers';

// react hook form
import {useForm} from 'react-hook-form';

// UI
import {
  TextField,
  Grid,
  Button,
  CardHeader,
  CardContent,
  Card,
  Paper,
  Typography,
  IconButton,
} from '@material-ui/core';

import {createStructuredSelector} from 'reselect';

import warehouseRepository from 'client-sdk/src/Repository/warehouses-repository';
// Component
import classes from './edit.module.scss';

// Type
import {User} from '../../../users/interfaces';
import handleError from '../../../../utils/handleError';
import handleNotfication from '../../../../utils/handleNotfication.tsx';
import RonadIcons from '../../../../components/iconComponent';

type Props = {
  data: any;
  update: (body: any, callback: () => void) => void;
  close: () => void;
  partnerId: number;
  supervisorsList: any[];
};

type Inputs = {
  suppliable: any;
  reserved: any;
  minimum: any;
};

// const
const user = {
  id: 0,
  name: '',
  phoneNumber: '',
  emailAddress: '',
  role: 'NONE',
  status: 'REGISTERED',
} as User;

function InventoryEditMobile(props: Props) {
  const {register, handleSubmit, errors, setValue} = useForm<Inputs>({
    mode: 'onChange',
  });

  useEffect(() => {
    warehouseInventory({
      variantId: {equals: props.match.params.id},
      warehouseId: {equals: props.match.params.warehouseId},
    });
  }, []);

  const warehouseInventory = async (actions: any) => {
    const payload = {...actions};
    try {
      const response = await warehouseRepository.getWarehouseInventory({
        payload,
      });
      const {suppliable, reserved, minimum} = response.data[0];
      setValue('suppliable', suppliable);
      setValue('reserved', reserved);
      setValue('minimum', minimum);
    } catch (error) {
      handleError(error);
    }
  };

  const updateInventory = async (actions: any) => {
    const payload = {...actions};
    try {
      const response = await warehouseRepository.updateWarehouseInventory({
        payload,
      });
      handleNotfication('موجودی انبار با موفقیت تغییر یافت', 'success');
      window.history.back();
    } catch (error) {
      handleError(error);
    }
  };

  const onSubmit = (data: Inputs) => {
    const {suppliable, reserved, minimum} = data;
    updateInventory({
      body: {
        suppliable,
        reserved,
        minimum,
        variantId: props.match.params.id,
        warehouseId: props.match.params.warehouseId,
      },
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid
        style={{
          zIndex: 10,
          backgroundColor: 'white',
          position: 'fixed',
          top: '6px',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={0}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '83%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              {`ویرایش موجودی`}
              <span> &nbsp; {props.match.params.id}</span>
            </Typography>
          </div>
          <IconButton
            aria-label="close"
            style={{marginLeft: '6px'}}
            onClick={() => window.history.back()}
          >
            <RonadIcons name="times" size={1}/>
          </IconButton>
        </Paper>
      </Grid>

      <Grid lg={12} md={12} container style={{marginTop: '16px'}}>
        <Grid md={12} lg={12} item spacing={2}>
          <Grid md={12} lg={12} item>
            <Card className={classes.card} style={{padding: '15px 0'}}>
              <CardHeader
                avatar={
                  <Grid>
                    <Typography
                      className={classes.typographyCards}
                      style={{marginRight: '-25px'}}
                    >
                      اطلاعات کلی کالا
                    </Typography>
                  </Grid>
                }
              />

              <CardContent className={classes.cardContentOrder}>
                <Grid container lg={12} md={12} className={classes.cardContent}>
                  <Grid container item spacing={2} lg={9} md={9}>
                    <Grid container item xs={6} sm={4} md={4} lg={4}>
                      <div className={classes.item}>
                        <div style={{width: '100%'}}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            id="minimum"
                            name="minimum"
                            defaultValue={' '}
                            label="نقطه سفارش مجدد"
                            inputRef={register({
                              required: true,
                            })}
                            error={errors.minimum && true}
                          />
                          {errors.minimum &&
                            errors.minimum.type === 'required' && (
                              <p className={classes.errorText}>
                                {'فیلد نقطه سفارش مجدد الزامیست'}
                              </p>
                            )}
                        </div>
                      </div>
                    </Grid>
                    <Grid container item xs={6} sm={4} md={4} lg={4}>
                      <div className={classes.item}>
                        <div style={{width: '100%'}}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            defaultValue={' '}
                            id="reserved"
                            name="reserved"
                            label="موجودی رزرو"
                            inputRef={register({
                              required: true,
                            })}
                            error={errors.reserved && true}
                          />
                          {errors.reserved &&
                            errors.reserved.type === 'required' && (
                              <p className={classes.errorText}>
                                {'فیلد موجودی رزرو الزامیست'}
                              </p>
                            )}
                        </div>
                      </div>
                    </Grid>
                    <Grid container item xs={6} sm={4} md={4} lg={4}>
                      <div className={classes.item}>
                        <div style={{width: '100%'}}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            defaultValue={' '}
                            id="suppliable"
                            name="suppliable"
                            label="موجودی قابل تامین"
                            inputRef={register({
                              required: true,
                            })}
                            error={errors.suppliable && true}
                          />
                          {errors.suppliable &&
                            errors.suppliable.type === 'required' && (
                              <p className={classes.errorText}>
                                {'فیلد موجودی قابل تامین الزامیست'}
                              </p>
                            )}
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid
          container
          lg={12}
          md={12}
          xs={12}
          style={{
            flexDirection: 'row-reverse',
            position: 'fixed',
            backgroundColor: '#fff',
            bottom: '0',
            right: '0',
            padding: '15px',
            zIndex: 2,
            borderTop: '1px solid #000',
          }}
        >
          <Grid container>
            <Button
              type="submit"
              size="medium"
              data-cy="saveBtn"
              autoFocus
              variant="contained"
              color="primary"
              style={{
                marginLeft: '14px',
                flex: '1 1 0',
                padding: '10px 0',
              }}
            >
              ذخیره تغییرات
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="medium"
              onClick={() => window.history.back()}
              style={{
                flex: '1 1 0',
                marginRight: 'auto',
                padding: '10px 0',
              }}
              data-cy="cancelBtn"
            >
              انصراف
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}

const mapStateToProps = createStructuredSelector<Store, any>({
  // centersList: makeSelectList(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    // centersDispatch: (payload: Object) => dispatch(getCentersAction(payload)),
    // updateCenterDispatch: (payload: PayloadUpdate) =>
    //   dispatch(updateCenterActions(payload)),
    // updateCenterStatusDispatch: (payload: {
    //   id: number;
    //   body: string;
    //   pagination: object;
    // }) => dispatch(updateCenterStatusActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(InventoryEditMobile);
